import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { Link } from 'react-router-dom';
import FormSection from 'components/sales/formSection/formSection';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import {toast} from "react-toastify";
import axios from "../../../services/interceptor/Interceptor";
import Config from "services/config/config";
import { handleValidateObj } from 'constants/objValues/objvalues';
import DivLayout from 'components/sales/divLayout/divLayout';
import "./pos.css";
import Images from 'assets/images/imageData';

const PosReturn = ({
  match,
  getPosShipmentAndReasons,
  posRequirement,
  replaceOrReturnPos
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isFiled, setIsFiled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const emailModalHide = () => setModal(false);
  const [isOpen, setIsOpen] = useState(false);
  const [role, setRole] = useState('');
  const [materialArray, setMaterialArray] = useState([]);
  const [duplicateData, setDuplicateData] = useState([]);
  const [isShow, setIsShow] = useState(true);
  const [details, setDetails] = useState([]);
  const [disabledBtn, setDisabledBtn] = useState(false);
  const [reasons, setReasons] = useState([]);
  const [isRow, setIsRow] = useState('');
  const [colSize, setColSize] = useState('col-md-6');
  const [isReturned, setIsReturned] = useState(false);
  
  console.log("PAGE::POS RETURN");
  useEffect(() => {
    let roles = JSON.parse(localStorage.getItem('roles'))
    setRole(roles[0]?.id)
    setIsOpen(!isOpen);
  }, []);

  useEffect(() => {
    if(window.innerWidth !== undefined) {
      if(window.innerWidth > 796) {
        setColSize('col-md-4')
        setIsRow('row');
      }
    }
  },[]);
    
  useEffect(() => {
    if (getPosShipmentAndReasons !== null && match.params.site_id && match.params.site_id == 0);
    (async () => {
      setIsLoading(true);
      await getPosShipmentAndReasons(match.params.site_id,2);
      setIsLoading(false);
    })();
  },[getPosShipmentAndReasons,match.params.site_id]);

  const handleStatusUpdate = async () => {
    var isError = false;
    materialArray.map((val) => {
      if(!handleValidateObj(val)) {
        isError = true;
      }
    });
      
    if(isError) {
       toast.error('Please select reason against all materials.');
       return false;
    }
    setDisabledBtn(true);
    setIsLoading(true);
    var payload = {
      'site_id':match.params.site_id,
      'type':2,
      'case':'return',
      'data': materialArray
    }
    const res = await replaceOrReturnPos(payload);
    if (res === true) {
        toast.success('Item returned.');
        setIsLoading(false);
        setTimeout(() => {
          window.location.reload()
      }, 4500);
    } else {
      toast.error('Failed.');
      setDisabledBtn(false);
    }
    setIsLoading(false);
  };

  const headerBtns = () => {
    return (
      <Fragment>
          <Button
            disabled={disabledBtn}
            className="btn btn-primary"
            onClick={() => handleStatusUpdate()}
          >
            {localization.replaceItems}
          </Button>
      </Fragment>
    );
  };

  useEffect(() => {
    if(posRequirement !== undefined) {
      if(posRequirement?.details != undefined && posRequirement?.details?.length > 0) {
          setReasons(posRequirement?.reasons);
          setIsReturned(posRequirement?.isReturned);
          const list = [...materialArray];
          var data = posRequirement.details;
          for(var i=0; i<data?.length; i++) {
            list[i] = {'id':data[i]?.id,'mat_id':data[i]?.material_id,'mat_name':data[i].material_name,'mat_code':data[i].material_code,'erp_serial_no':data[i].erp_serial_number,'old_serial_number':data[i].serial_number,'reason':'','reason_value':'','amount':'','isReturnableChecked':true};
          }
          setMaterialArray([...list]);
      }
    }
  },[posRequirement]);

  const fetchAmount = async (val,index,key) => {
    if(val !== undefined && val !== '') {
      const payload = {
        'data': val
     };
     const url = `${Config.installation.fetchAmountAgainstPos}`;
     const amount = await axios.post(url,payload);
      let list = [...materialArray];
      if(amount && amount?.data) {
        list[index]['amount'] = amount?.data;
      } else {
        list[index]['amount'] = 0;
      }
      setMaterialArray([...list]);
    }
  }

  const handleValue = (val,key,index) => {
    if(val) {
      var flag = false;
      let list = [...materialArray];
      if(key === 'new_serial_number') {
        if(duplicateData.includes(val)) {
          toast.error('Serial number already selected');
          flag = false;
        } else { 
          duplicateData.push(val);
          flag = true;
        }
        list[index][key] = (flag) ? val : '';
      } else if(key === 'reason') {
        list[index][key] = val;
        list[index]['reason_value'] = 'NA';
      } else {
        list[index][key] = val;
      }  
      setMaterialArray([...list]);
    }
    console.log('data ' + JSON.stringify(materialArray));
  }

  console.log('00 -> ' + JSON.stringify(materialArray));

  return (
    <Layout
      title={localization.POSReturn}
      Buttons={(materialArray?.length > 0 && !isReturned) ? headerBtns : null}
      className={isFiled ? 'requiredFileds' : ''}
      isGoback
      linkFlag={true}
      linkUrl={`/dashboard/public-sites`}
      isLoading={isLoading}
    >
          <>
          {materialArray?.length > 0 && !isReturned ?
          <FormSection title={localization.POSReturn}>
            <div className="panel-body" style={{'marginBottom':'3rem'}}>
            <>
              {materialArray && materialArray?.length > 0 && materialArray.map((item,key) => {
                return (
                <div className={`col-md-12 auto-w-100 auto-design-2 ` + isRow} key={key}>
                  <div className={colSize}>
                    <ConstantInput
                        label={localization.material}
                        isStarRequired={false}
                        disabled={true}
                        value={item['mat_name'] + ` (` + item['old_serial_number'] + `)`}
                        errorMsg={localization.isRequired}
                    />
                  </div>
                  {/* <div className='col-3'>
                    <DropDownInput
                      name="serial_number"
                      data={item['erp_serial_no']}
                      label={localization.serialNo}
                      required={true}
                      isStarRequired={true}
                      errorMsg={localization.isRequired}
                      getIdValue={(val) => handleValue(val.id,'new_serial_number',key)}
                      value={item['new_serial_number']}
                    />
                  </div> */}
                  <div className={colSize}>
                    <DropDownInput
                      name="reason"
                      data={reasons}
                      label={localization.reason}
                      required={true}
                      isStarRequired={true}
                      errorMsg={localization.isRequired}
                      getIdValue={(val) => {
                        handleValue(val,'reason',key);
                        fetchAmount(val,key,'reason');
                        }
                      }
                      value={item['reason_value']}
                      multipule={true}
                    />
                  </div>
                  <div className={colSize}>
                    <ConstantInput
                        label={localization.amount}
                        isStarRequired={false}
                        disabled={true}
                        errorMsg={localization.isRequired}
                        value={item['amount']}
                    />
                  </div>
                </div>
                )
              })
              }
             </>
            </div>
          </FormSection>
          :<div>
            <img src={Images?.NoData} alt="" width="100%" />
          </div>}
          </>
    </Layout>
  );
};
export default PosReturn;
